export const REGIONS = {
  '03': [
    {
      name: 'welcome.astana_bil',
      contacts: [
        {
          phone: '+7 7172 53 88 54',
        },
        { phone: '+7 705 131 56 02', hasWhatsapp: true },
      ],
      address: 'welcome.astana_bil_address',
    },
    {
      name: 'welcome.astana_kyz',
      contacts: [
        {
          phone: '+7 775 707 78 96',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.astana_kyz_address',
    },
    {
      name: 'welcome.kokshetau_bil',
      contacts: [
        {
          phone: '+7 771 595 77 76',
          hasWhatsapp: true,
        },
      ],
      // address: 'welcome.kokshetau_bil_address',
    },
    {
      name: 'welcome.kokshetau_kyz_bil',
      contacts: [
        {
          phone: '+7 771 595 77 76',
          hasWhatsapp: true,
        },
      ],
      // address: 'welcome.kokshetau_kyz_bil_address',
    },
    {
      name: 'welcome.shuchinsk_bil',
      contacts: [
        {
          phone: '+7 7163 62 11 45',
          hasWhatsapp: false,
        },
        {
          phone: '+7 771 113 40 97',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.shuchinsk_bil_address',
    },
  ],
  '04': [
    // Aqtobe
    {
      name: 'welcome.aqtobe_bil',
      contacts: [
        {
          phone: '+7 7132 46 71 77',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.aqtobe_bil_address',
    },
  ],
  '05': [
    // Almaty, Almaty oblast
    {
      name: 'welcome.almaty_bil',
      contacts: [
        {
          phone: '+7 727 230 69 43',
          hasWhatsapp: false,
        },
        {
          phone: '+7 706 630 69 43',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.almaty_bil_address',
    },
    {
      name: 'welcome.almaty_smagul_bil',
      contacts: [
        {
          phone: '+7 727 376 26 05',
          hasWhatsapp: false,
        },
        {
          phone: '+7 747 104 40 83',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.almaty_smagul_bil_address',
    },
    {
      name: 'welcome.esik_bil',
      contacts: [
        {
          phone: '+7 707 498 34 56',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.esik_bil_address',
    },
  ],
  '06': [
    // Atyrau
    {
      name: 'welcome.atyrau_bil',
      contacts: [
        {
          phone: '+7 778 133 77 88',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.atyrau_bil_address',
    },
    {
      name: 'welcome.atyrau_kyz',
      contacts: [
        // {
        //   phone: '+7 7122 30 43 55',
        //   hasWhatsapp: false,
        // },
        {
          phone: '+7 778 871 53 84',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.atyrau_kyz_address',
    },
    {
      name: 'welcome.kulsary_bil',
      contacts: [
        {
          phone: '+7 775 568 49 35',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.kulsary_bil_address',
    },
  ],
  '07': [
    // ZKO
    {
      name: 'welcome.oral_bil',
      contacts: [
        {
          phone: '+7 706 430 10 46',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.oral_bil_address',
    },
  ],
  '08': [
    // Zhambyl
    {
      name: 'welcome.taraz_bil',
      contacts: [
        {
          phone: '+7 7262 45 14 15',
          hasWhatsapp: false,
        },
        {
          phone: '+7 778 171 73 79',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.taraz_bil_address',
    },
    {
      name: 'welcome.taraz_kyz',
      contacts: [
        {
          phone: '+7 7262 57 74 66',
          hasWhatsapp: false,
        },
        {
          phone: '+7 747 102 05 84',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.taraz_kyz_address',
    },
  ],
  '09': [
    // Karaganda
    {
      name: 'welcome.karagandy_bil',
      contacts: [
        {
          phone: '+7 771 358 61 38',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.karagandy_bil_address',
    },
    {
      name: 'welcome.karagandy_kyz',
      contacts: [
        {
          phone: '+7 7212 25 56 07',
          hasWhatsapp: false,
        },
        {
          phone: '+7 778 281 08 27',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.karagandy_kyz_address',
    },
  ],
  10: [
    // Kostanay
    {
      name: 'welcome.kostanay_bil',
      contacts: [
        {
          phone: '+7 706 600 45 46',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.kostanay_bil_address',
    },
  ],
  11: [
    // Kyzylorda
    {
      name: 'welcome.kyzylorda_bil',
      contacts: [
        {
          phone: '+7 7242 21 24 92',
          hasWhatsapp: false,
        },
        {
          phone: '+7 707 255 00 09',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.kyzylorda_bil_address',
    },
    {
      name: 'welcome.kyzylorda_kyz',
      contacts: [
        {
          phone: '+7 7242 70 00 80',
          hasWhatsapp: false,
        },
        {
          phone: '+7 707 255 00 10',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.kyzylorda_kyz_address',
    },
    {
      name: 'welcome.kyzylorda_phizmat',
      contacts: [
        {
          phone: '+7 7242 71 15 64',
          hasWhatsapp: false,
        },
        {
          phone: '+7 747 255 10 09',
          hasWhatsapp: true,
        },
      ],
      address: '',
      // address: 'welcome.kyzylorda_bil_address',
    },
  ],
  12: [
    // Mangystau
    {
      name: 'welcome.aqtau_bil',
      contacts: [
        {
          phone: '+7 7292 33 84 27',
          hasWhatsapp: false,
        },
        {
          phone: '+7 777 112 93 77',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.aqtau_bil_address',
    },
    {
      name: 'welcome.zhanaozen_bil',
      contacts: [
        {
          phone: '+7 7293 45 59 76',
          hasWhatsapp: false,
        },
        {
          phone: '+7 747 670 87 44',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.zhanaozen_bil_address',
    },
  ],
  13: [
    // Shymkent, Turkestan oblast
    {
      name: 'welcome.shymkent_bil',
      contacts: [
        {
          phone: '+7 7252 32 11 56',
          hasWhatsapp: false,
        },
        {
          phone: '+7 700 235 93 89',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.shymkent_bil_address',
    },
    {
      name: 'welcome.shymkent_kyz',
      contacts: [
        {
          phone: '+7 7252 95 47 93',
          hasWhatsapp: false,
        },
        {
          phone: '+7 747 635 67 34',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.shymkent_kyz_address',
    },
    {
      name: 'welcome.turkestan_bil',
      contacts: [
        {
          phone: '+7 702 790 85 05',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.turkestan_bil_address',
    },
    {
      name: 'welcome.turkestan_kyz_bil',
      contacts: [
        {
          phone: '+7 708 925 64 22',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.turkestan_kyz_bil_address',
    },
    {
      name: 'welcome.arys_bil',
      contacts: [
        {
          phone: '+7 7254 02 16 54',
          hasWhatsapp: false,
        },
        {
          phone: '+7 705 566 16 40',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.arys_bil_address',
    },
  ],
  14: [
    // Pavlodar
    {
      name: 'welcome.pavlodar_bil',
      contacts: [
        {
          phone: '+7 7182 31 03 62',
          hasWhatsapp: false,
        },
        {
          phone: '+7 700 031 03 62',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.pavlodar_bil_address',
    },
    {
      name: 'welcome.pavlodar_kyz',
      contacts: [
        {
          phone: '+7 7182 60 71 98',
          hasWhatsapp: false,
        },
        {
          phone: '+7 708 380 21 49',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.pavlodar_kyz_address',
    },
    {
      name: 'welcome.ekibastuz_bil',
      contacts: [
        {
          phone: '+7 7187 74 00 37',
          hasWhatsapp: false,
        },
        {
          phone: '+7 777 541 56 46',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.ekibastuz_bil_address',
    },
  ],
  15: [
    // SKO
    {
      name: 'welcome.petropavl_bil',
      contacts: [
        {
          phone: '+7 7152 51 72 31',
          hasWhatsapp: false,
        },
        {
          phone: '+7 705 204 57 07',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.petropavl_bil_address',
    },
  ],
  16: [
    // VKO
    {
      name: 'welcome.oskemen_bil',
      contacts: [
        {
          phone: '+7 723 225 29 62',
          hasWhatsapp: false,
        },
        {
          phone: '+7 705 187 58 01',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.oskemen_bil_address',
    },
  ],
  18: [
    // Abay
    {
      name: 'welcome.semey_bil',
      contacts: [
        {
          phone: '+7 722 277 15 76',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.semey_bil_address',
    },
  ],
  19: [
    // Zhetisu
    {
      name: 'welcome.taldykorgan_bil',
      contacts: [
        {
          phone: '+7 7282 22 26 69',
          hasWhatsapp: false,
        },
        {
          phone: '+7 700 024 72 82',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.taldykorgan_bil_address',
    },
  ],
  20: [
    // Ulutau
    {
      name: 'welcome.zhezkazgan_bil',
      contacts: [
        {
          phone: '+7 7102 41 00 99',
          hasWhatsapp: false,
        },
        {
          phone: '+7 700 113 19 93',
          hasWhatsapp: true,
        },
      ],
      address: 'welcome.zhezkazgan_bil_address',
    },
  ],
};
